@let vs = presenter.viewState();

<spa-table
  [columns]="columns()"
  [compareRows]="compareRows()"
  [dxPageSize]="dxPageSize()"
  [dxPageSizes]="pageSizeOptions()"
  [hideSelectedRow]="!vs.selectable"
  [loading]="vs.loading"
  [noDataLabel]="vs.noDataLabel"
  [rows]="rows()"
  [selectedRow]="$any(selectedRow())"
  (paginate)="onPaginate($event)"
  (selectedRowChange)="onRowClick($event)"
>
  @for (renderColumn of vs.renderColumns; track renderColumn.column.key) {
    @if (renderColumn.column.cellTemplate; as cellTemplate) {
      <spa-col-tpl [columnKey]="renderColumn.column.key">
        <ng-template let-row="row">
          <ng-container
            *ngTemplateOutlet="
              $any(cellTemplate);
              context: { $implicit: row.element, row: row.element, column: renderColumn.column }
            "
          />
        </ng-template>
      </spa-col-tpl>
    }
  }

  @if (vs.actionsTemplate; as actionsTemplate) {
    <spa-col-tpl [columnKey]="vs.actionsColumnKey">
      <ng-template let-row="row">
        <ng-container
          *ngTemplateOutlet="$any(actionsTemplate); context: { $implicit: row.element, row: row.element }"
        />
      </ng-template>
    </spa-col-tpl>
  }
</spa-table>
